import { render, staticRenderFns } from "./PointExpireConfig.vue?vue&type=template&id=6650eb03"
import script from "./PointExpireConfig.vue?vue&type=script&lang=js"
export * from "./PointExpireConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports